import WaitlistUserCreateForm from "../ui-components/WaitlistUserCreateForm";

export default function WaitlistScreen(props) {
    return (
        <WaitlistUserCreateForm />
    );
}